/**
 * IMPORTS
 */

import { useCallback } from "react";

import { toast } from "react-toastify";

import { type ObservacaoFormData, ObservacaoFormModal } from "@components/observacao-form-modal";

import { useUpdateTarefa } from "@/hooks/minhas-tarefas/use-update-tarefa";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { FEATURES, useFeature } from "@/utils/auth/features";

import { IObservationModalProps } from "./interface";

const ObservationExpedicaoModal = ({
  handleToggleCreateActvityModal,
  remessa,
}: IObservationModalProps) => {
  const { user } = useStoreZustandUserAuth();
  const podeAdicionarObservacao = useFeature(FEATURES.ADICIONAR_OBSERVACAO_REMESSAS);

  const { mutate: mutateUseUpdateTarefa, isPending } = useUpdateTarefa();

  const onSubmit = useCallback(
    (data: ObservacaoFormData) => {
      if (!user?.id) {
        toast.error("Usuário não autenticado.");
        return;
      }

      mutateUseUpdateTarefa(
        {
          id_remessa: Number(remessa?.remessa),
          payload: {
            observacao: data.observation || "N/A",
          },
        },
        {
          onSuccess: () => {
            handleToggleCreateActvityModal();
          },
          onError: () => {
            handleToggleCreateActvityModal();
          },
        }
      );
    },
    [remessa, user?.id, mutateUseUpdateTarefa, handleToggleCreateActvityModal]
  );

  return (
    <ObservacaoFormModal
      title="Observação"
      submitLabel="Salvar"
      showSubmit={podeAdicionarObservacao}
      initialObservacao={String(remessa?.observacao ?? "")}
      isSubmitting={isPending}
      textareaDisabled={isPending || !podeAdicionarObservacao}
      onClose={handleToggleCreateActvityModal}
      onSubmit={onSubmit}
    />
  );
};

export { ObservationExpedicaoModal };
